<template>
	<div class="taskflowConf">
		<el-row :gutter="20">
			<el-col class="left-content" :span="6">
				<!-- 任务流 -->
				<el-card class="box-card">
					<div slot="header" class="clearfix">
						<span>{{ propName }}</span>
						<el-button
							style="float: right; padding: 3px 0;"
							type="text"
							@click="dialogVisible = true"
							>新增
						</el-button>
					</div>
					<el-tree
						@node-drop="nodeDrop"
						draggable
						:allow-drop="allowDrop"
						@node-click="click"
						:data="taskflow"
						check-on-click-node
						highlight-current
						node-key="id"
						:props="props"
						default-expand-all
						:expand-on-click-node="false"
					>
						<div class="custom-tree-node" slot-scope="{ node, data }">
							<span>
								<span>{{ node.label }}</span>
								<span class="group-item">{{ data.taskGroupName }}</span>
							</span>

							<span>
								<!--<el-button type="text" size="mini" v-if="node" @click="() => append(data)">添加</el-button>-->
								<el-button
									type="text"
									size="mini"
									@click.stop="() => remove(node, data)"
									icon="el-icon-delete"
								></el-button>
							</span>
						</div>
					</el-tree>
				</el-card>

				<!-- 任务组 -->
				<el-card style="margin-top: 10px;">
					<div slot="header" class="clearfix">
						<span>任务组</span>
						<!--<el-button style="float: right; padding: 3px 0" type="text" @click="addGroup">新增</el-button>-->
					</div>
					<!--<div v-if="taskGroup.length === 0">暂无数据...</div>-->
					<div class="task-groups">
						<el-tag :key="item.name" v-for="item in taskGroup" closable @close="removeTag(item)">
							{{ item.name }}
							<i class="el-icon-edit" @click="edit(item)"></i>
						</el-tag>
						<el-input
							class="input-new-tag"
							v-if="inputVisible"
							v-model="inputValue"
							size="small"
							ref="saveTagInput"
							@keyup.enter.native="inputConfirm"
							@blur="inputConfirm"
						>
						</el-input>
						<el-button v-else class="button-new-tag" size="mini" @click="showInput"
							>新增任务组</el-button
						>
					</div>
				</el-card>
			</el-col>

			<!-- 任务属性 -->
			<el-col :span="18" v-if="taskDetailObj">
				<el-card>
					<div slot="header" class="clearfix">
						<span>任务属性</span>
					</div>

					<form-combination :form-data="taskDetail"></form-combination>
					<!-- 自动触发任务列表 -->
					<el-row class="auto-trigger" v-if="showTrigger">
						<el-col :span="24" class="trigger-title">
							<div class="title">触发列表</div>
							<el-button type="primary" size="mini" plain @click="addTrigger">新增</el-button>
						</el-col>
						<el-col :span="24">
							<data-list
								:table-style="{ name: 'webclient' }"
								:data="taskDetailObj.triggerList"
								:columns="columns"
								:loading="dataListLoading"
							></data-list>
						</el-col>
					</el-row>
					<el-row type="flex" style="justify-content: flex-end;">
						<!-- <el-button @click="dialogVisible = false">取 消</el-button> -->
						<el-button type="primary" :loading="btnLoading" @click="save">保 存</el-button>
					</el-row>
				</el-card>
			</el-col>
		</el-row>

		<!-- 任务流配置表单 -->
		<dialog-form
			:dialogVisible.sync="dialogVisible"
			:formData="groups"
			@close:dialogVisible="val => (dialogVisible = val)"
			@confirm="setSubmit"
		></dialog-form>

		<!-- 新增触发列表 -->
		<dialog-form
			:dialogVisible.sync="autoDialogVisible"
			:formData="autotriggerGroups"
			:attributes="attributes"
			@close:dialogVisible="val => (autoDialogVisible = val)"
			@confirm="triggerSubmit"
		></dialog-form>
	</div>
</template>

<script>
import taskflow from '@/backend/services/task/taskflow';
import formCombination from '@/components/iglobalwin/formCombination/formCombination.vue';
import simpleFormPageCreate from '@/components/iglobalwin/formCombination/formService.js';
import api from '@/backend/apiConfig/apiConfig';
import { validRequired } from '@/common/elementValid';
import dialogForm from '@/components/dialogForm/dialogForm';
import { taskflowRichtext } from '@/common/dictionary';
import userSearch from '@/components/tools/userSearch';
import {
	triggerCondition,
	autoTriggerResult,
	triggerMessage,
	triggerCopy,
} from '@/common/dictionary.js';

export default {
	name: 'taskflowConf',
	components: {
		formCombination,
		dialogForm,
	},
	data() {
		return {
			propName: '',
			taskflow: [],
			dialogVisible: false,
			props: {
				label: 'name',
				children: 'taskRules',
			},
			groups: {},
			taskGroup: [],
			btnLoading: false,
			taskDetail: {},
			taskDetailObj: null,
			inputVisible: false,
			inputValue: '',
			loading: false,
			columns: [],
			autoDialogVisible: false,
			autotriggerGroups: {},
			showTrigger: true,
			dataListLoading: false,
			triggerDisabled: false,
			triggerStatus: false,
			submitStatu: false,
			activeTrigger: {},
			activeTaskFlowId: '',
			attributes: {
				width: '70%',
				clickModal: false,
			},
			triggerType: 'all',
		};
	},
	created() {
		this.propName = decodeURIComponent(this.$route.query.name);
		this.getTaskflow();
		this.getTaskGroup();
		this.setColumns();
		this.setAutotriggerGroups();
		this.setTaskDetail();
	},
	methods: {
		confirm1(callback) {
			setTimeout(() => {
				this.autoDialogVisible = false;
				callback();
			}, 3000);
		},
		cancel1(callback) {
			setTimeout(() => {
				this.autoDialogVisible = false;
				callback();
			}, 3000);
		},

		allowDrop(draggingNode, dropNode, type) {
			if (type == 'inner') {
				return false;
			} else if (draggingNode.level !== dropNode.level) {
				return false;
			}
			return true;
		},
		nodeDrop(dragNode, dropNode, type) {
			let taskType = type == 'before' ? 1 : 2;
			taskflow
				.changeTaskRuleOrder(dragNode.data.id, {
					dropId: dropNode.data.id,
					type: taskType,
				})
				.then(val => {
					if (val) {
						this.$message.success('移组成功');
					}
				});
		},
		showInput() {
			this.inputVisible = true;
			this.$nextTick(() => {
				this.$refs.saveTagInput.$refs.input.focus();
			});
		},
		inputConfirm() {
			let inputValue = this.inputValue;
			if (inputValue) {
				this.addGroup(inputValue);
			}
		},
		edit(item) {
			this.$prompt('提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				inputValue: item.name,
			})
				.then(({ value }) => {
					taskflow.editTaskGroup(item.id, { name: value }).then(() => {
						this.$message.success('修改成功');
						this.getTaskGroup();
					});
				})
				.catch(err => {
					console.log(err);
				});
		},
		addGroup(value) {
			taskflow
				.addTaskGroup({
					name: value,
				})
				.then(val => {
					if (val) {
						this.getTaskGroup();
						this.inputVisible = false;
						this.inputValue = '';
					}
				});
		},
		async click({ id }) {
			try {
				this.dataListLoading = true;
				this.activeTaskFlowId = id;
				let val = await this.getDetail(id);
				this.taskDetailObj = val.data;
				this.showTrigger = val.data.flagTriggerNotice;
				this.setTaskDetail(val.data);
				this.dataListLoading = false;
			} catch (error) {
				this.dataListLoading = false;
			}
		},
		getDetail(id) {
			return taskflow.getTaskRuleDetail(id);
		},
		save() {
			this.submit(this.taskDetailObj);
		},
		setSubmit(callback) {
			this.submit({}, callback);
		},
		submit(groups = {}, callback) {
			if (!this.taskDetail.limitFunction.value) {
				this.taskDetail.limitFunction.value = null;
			}
			let [requestApi, type] = [api.taskflow.addTaskRule, 'Post'];
			if (groups.id) {
				type = 'Patch';
				requestApi = api.taskflow.editTaskRule + groups.id;
			}
			simpleFormPageCreate(
				{
					api: requestApi,
					type: type,
					data: groups.id ? this.taskDetail : this.groups,
				},
				res => {
					let obj = Object.assign({}, res);
					obj.taskFlowId = this.$route.query.id;
					obj.file = obj.file && obj.file.length > 0 ? obj.file[0] : null;
					return obj;
				}
			)
				.submit()
				.then(() => {
					this.$message.success('保存成功');
					this.btnLoading = false;
					this.dialogVisible = false;
					this.getTaskflow();
					callback && callback();
				})
				.catch(() => {
					this.btnLoading = false;
					callback && callback();
				});
		},
		setTaskDetail(obj = {}) {
			const that = this;
			this.taskDetail = {
				flagMainService: {
					label: '设为主服务',
					formType: 'sky-switch',
					value: obj.flagMainService,
					displayWith() {
						return obj.flagMainTask;
					},
				},
				name: {
					label: '任务名称',
					formType: 'sky-input',
					value: obj.name,
				},
				taskGroupId: {
					label: '任务组',
					formType: 'sky-select',
					options: this.taskGroup,
					props: {
						label: 'name',
						value: 'id',
					},
					value: obj.taskGroupId,
				},
				defaultProp: {
					label: '固定属性',
					formType: 'sky-checkbox',
					options: [
						{
							label: '负责人',
							value: 1,
							disabled: true,
						},
						{
							label: '处理人',
							value: 2,
							disabled: true,
						},
						{
							label: '到期日',
							value: 3,
							disabled: true,
						},
						{
							label: '描述',
							value: 4,
							disabled: true,
						},
					],
					value: [1, 2, 3, 4],
				},
				serviceStaffId: {
					label: '固定服务人员',
					formType: userSearch,
					value: obj.serviceStaffId,
				},
				limitFunction: {
					label: '限制功能',
					formType: 'sky-select',
					options: [{ label: '网站上线', value: 1 }],
					value: obj.limitFunction,
				},
				smallProgramIsDisplayed: {
					label: '是否客户端显示',
					formType: 'sky-radio',
					options: [
						{
							label: '是',
							value: true,
						},
						{
							label: '否',
							value: false,
						},
					],
					value: obj.smallProgramIsDisplayed,
				},
				file: {
					label: '任务流图标',
					formType: 'sky-uploadImg',
					value: obj.file ? [obj.file] : [],
					platform: 'iglobalwin-pri-oss',
					accept: 'image/jpeg, image/png, image/gif',
					limit: 1,
				},
				flagTriggerNotice: {
					label: '自动触发',
					formType: 'sky-switch',
					value: obj.flagTriggerNotice,
					change(val) {
						that.save();
						that.showTrigger = val;
					},
				},
			};
		},
		setGroups(obj = {}) {
			const that = this;
			this.groups = {
				name: {
					label: '任务名称',
					formType: 'sky-input',
					value: obj.name,
					rules: [validRequired(), 'blur'],
				},
				parentId: {
					label: '所属任务流',
					formType: 'sky-select',
					options: that.taskflow,
					props: {
						label: 'name',
						value: 'id',
					},
					value: obj.parentId,
				},
				sort: {},
			};
		},
		getTaskflow() {
			taskflow
				.getTaskRuleList({
					taskFlowId: this.$route.query.id,
				})
				.then(val => {
					this.taskflow = val.data;
					this.setGroups();
				});
		},
		getTaskGroup() {
			taskflow.getTaskGroup().then(val => {
				this.taskGroup = val.data;
			});
		},
		remove(node, data) {
			const that = this;
			this.deleteItem({
				api: taskflow.deleteTaskRule,
				id: data.id,
				callback() {
					that.getTaskflow();
				},
			});
		},
		removeTag(item) {
			const that = this;
			that.deleteItem({
				api: taskflow.deleteTaskGroup,
				id: item.id,
				callback() {
					that.getTaskGroup();
				},
			});
		},
		deleteItem({ api, id, callback }) {
			this.$confirm('是否确认删除?', '提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning',
			})
				.then(() => {
					api(id).then(val => {
						if (val) {
							this.$message({
								message: '删除成功',
								type: 'success',
							});
							callback();
						}
					});
				})
				.catch(() => {});
		},
		setColumns() {
			let that = this;
			this.columns = [
				{
					label: '触发类型',
					bind: 'type',
					type: 'percentage',
					dataStyle(val) {
						switch (val) {
							case 2:
								return '服务评价';
							case 1:
								return '邮件发送';
						}
					},
				},
				{
					label: '触发条件',
					bind: 'conditionField',
					type: 'percentage',
					dataStyle(val) {
						switch (val) {
							case 1:
								return '任务状态';
							case 2:
								return '负责人';
							case 3:
								return '处理人';
							case 4:
								return '时间';
						}
					},
				},
				{
					label: '条件结果',
					bind: 'conditionStatus',
					type: 'percentage',
					dataStyle(val) {
						switch (val) {
							case 1:
								return '变为待开始';
							case 2:
								return '变为进行中';
							case 3:
								return '变为已完成';
							case 4:
								return '状态变更';
						}
					},
				},
				{
					label: '发送内容',
					bind: 'content',
					type: 'popoverView',
				},
				{
					label: '通知对象',
					bind: 'recipientList',
					type: 'mapping',
					width: 150,
					mapType: 'multidata',
					colors() {
						return {
							fontSize: '14px',
							padding: '5px 0',
						};
					},
					multidata(val) {
						if (!val || val.length === 0) return '-';
						val.indexOf('1') !== -1 && val.splice(val.indexOf('1'), 1, '客户账号邮箱');
						val.indexOf('2') !== -1 && val.splice(val.indexOf('2'), 1, '网站通知邮箱');
						val.indexOf('3') !== -1 && val.splice(val.indexOf('3'), 1, '默认管理员');
						return val;
					},
				},
				{
					label: '抄送',
					bind: 'ccPeopleList',
					type: 'mapping',
					mapType: 'multidata',
					colors() {
						return {
							fontSize: '14px',
							padding: '5px 0',
						};
					},
					multidata(val) {
						if (!val) return false;
						val.splice(val.indexOf('1'), 1, '负责人');
						val.splice(val.indexOf('2'), 1, '处理人');
						return val;
					},
				},
				{
					label: '评价模板',
					bind: 'evaluationTemplate',
					type: 'percentage',
					dataStyle(val) {
						switch (val) {
							case 1:
								return '网建顾问评价模板';
							case 2:
								return '询盘顾问评价模板';
							case 3:
								return '商务顾问评价模板';
							case 4:
								return '视频顾问评价模板';
							default:
								return '-';
						}
					},
				},
				{
					label: '附件',
					bind: 'fileList',
					type: 'mapping',
					width: 100,
					mapType: 'multidata',
					multidataType: 'icon',
					trigger: 'hover',
					colors() {
						return {
							fontSize: '22px',
							padding: '8px 5px',
							cursor: 'pointer',
						};
					},
					multidata(val) {
						if (!val) return false;
						val.forEach(item => {
							item.icon = 'duowenjian';
							item.content = item.fileName;
						});
						return val;
					},
					multidataEvent(item) {
						window.open(item.url);
					},
				},
				{
					label: '操作',
					type: 'btnClick',
					width: 220,
					bind: [
						{
							text: '查看',
							async trigger(row) {
								that.submitStatu = true;
								that.triggerDisabled = true;
								that.autoDialogVisible = true;
								let res = await taskflow.autoTriggerDetail(row.id);
								if (res.data.type === 1) {
									that.triggerType = 'email';
								} else {
									that.triggerType = 'evaluate';
								}
								that.setAutotriggerGroups(res.data, autoTriggerResult);
							},
						},
						{
							text: '编辑',
							async trigger(row) {
								that.submitStatu = '编辑';
								that.triggerStatus = true;
								that.triggerDisabled = false;
								that.autoDialogVisible = true;
								let res = await taskflow.autoTriggerDetail(row.id);
								if (res.data.type === 1) {
									that.triggerType = 'email';
								} else {
									that.triggerType = 'evaluate';
								}
								that.activeTrigger = res.data;
								that.setAutotriggerGroups(res.data, autoTriggerResult);
							},
						},
						{
							text: '删除',
							async trigger(row) {
								let res = await taskflow.deleteAutoTrigger(row.id);
								if (res.status == '204') {
									that.click({ id: that.activeTaskFlowId });
									that.$message.success('删除成功');
								}
							},
						},
					],
				},
			];
		},
		// 新增触发列表
		addTrigger() {
			this.triggerType = 'all';
			this.submitStatu = false;
			this.triggerStatus = false;
			this.triggerDisabled = false;
			this.autoDialogVisible = true;
			this.setAutotriggerGroups();
		},
		setAutotriggerGroups(obj = {}, conditionField = []) {
			let that = this;
			let { triggerDisabled, triggerStatus } = this;
			this.autotriggerGroups = {
				type: {
					label: '触发类型',
					formType: 'sky-select',
					value: obj.type,
					options: [
						{ label: '邮件发送', value: 1 },
						{ label: '服务评价', value: 2 },
					],
					disabled: triggerDisabled || triggerStatus,
					rules: [validRequired('此项必填', 'blur', 'number')],
					change(val) {
						that.conditionType(val);
					},
				},
				conditionField: {
					label: '触发条件',
					formType: 'sky-select',
					value: obj.conditionField,
					options: triggerDisabled || triggerStatus ? triggerCondition : [],
					disabled: triggerDisabled,
					rules: [validRequired('此项必填', 'blur', 'number')],
					change(val) {
						that.conditionField(val);
					},
				},
				conditionStatus: {
					label: '条件结果',
					formType: 'sky-select',
					value: obj.conditionStatus,
					options: conditionField,
					disabled: triggerDisabled,
					rules: [validRequired('此项必填', 'blur', 'number')],
				},
				recipientList: {
					label: '通知对象',
					formType: 'sky-select',
					multiple: true,
					value: obj.recipientList || [],
					options:
						that.triggerType === 'email' ? triggerMessage : [{ label: '默认管理员', value: '3' }],
					disabled: triggerDisabled,
					rules: [validRequired('此项必填', 'blur', 'array')],
					displayWith() {
						return that.triggerType === 'email' || that.triggerType === 'all';
					},
				},
				ccPeopleList: {
					label: '抄送',
					formType: 'sky-select',
					multiple: true,
					value: obj.ccPeopleList || [],
					options: triggerCopy,
					disabled: triggerDisabled,
					rules: [validRequired('此项必填', 'blur', 'array')],
					displayWith() {
						return that.triggerType === 'email' || that.triggerType === 'all';
					},
				},
				title: {
					label: '邮件Title',
					formType: 'sky-input',
					value: obj.title,
					disabled: triggerDisabled,
					rules: [validRequired('此项必填', 'blur')],
					displayWith() {
						return that.triggerType === 'email' || that.triggerType === 'all';
					},
				},
				evaluationTemplate: {
					label: '评价模板',
					formType: 'sky-select',
					options: [
						{
							label: '网建顾问评价模板',
							value: 1,
						},
						{
							label: '询盘顾问评价模板',
							value: 2,
						},
						{
							label: '商务顾问评价模板',
							value: 3,
						},
						{
							label: '视频顾问评价模板',
							value: 4,
						},
					],
					disabled: triggerDisabled,
					value: obj.evaluationTemplate,
					rules: [validRequired('此项必填', 'blur')],
					displayWith() {
						return that.triggerType === 'evaluate' || that.triggerType === 'all';
					},
				},
				fileList: {
					label: '附件',
					formType: 'sky-uploadImg',
					value: obj.fileList || [],
					platform: 'iglobalwin-pub-oss',
					disabled: triggerDisabled,
					displayWith() {
						return that.triggerType === 'email' || that.triggerType === 'all';
					},
				},
				content: {
					label: '发送内容',
					formType: 'sky-richtext',
					options: taskflowRichtext,
					value: obj.content,
					placeholder: '请输入内容',
					rules: [validRequired()],
					displayWith() {
						return that.triggerType === 'email' || that.triggerType === 'all';
					},
				},
			};
		},
		conditionType(val) {
			if (val === 1) {
				this.triggerType = 'email';
				this.autotriggerGroups.recipientList.options = triggerMessage;
			} else if (val === 2) {
				this.triggerType = 'evaluate';
				this.autotriggerGroups.recipientList.options = [{ label: '默认管理员', value: '3' }];
			} else {
				this.triggerType = 'all';
			}

			Object.keys(this.autotriggerGroups).forEach(item => {
				if (item !== 'type') {
					this.autotriggerGroups[item].value = '';
				}
				if (item === 'fileList' || item === 'recipientList' || item === 'ccPeopleList') {
					this.autotriggerGroups[item].value = [];
				}
			});
			this.autotriggerGroups.conditionField.options = triggerCondition;
		},
		conditionField(val) {
			if (val == 1) {
				this.autotriggerGroups.conditionStatus.value = '';
				this.autotriggerGroups.conditionStatus.options = autoTriggerResult;
			} else if (val != 1 && val != undefined) {
				this.autotriggerGroups.conditionStatus.value = '';
				this.autotriggerGroups.conditionStatus.options = autoTriggerResult.slice(0, 1);
			}
		},
		triggerSubmit(callback) {
			// 查看
			if (this.triggerDisabled) {
				this.autoDialogVisible = false;
				return false;
			}
			// 新增 / 编辑
			let [requestApi, type] = [api.taskflow.newAutoTrigger, 'Post'];

			// 编辑
			if (this.submitStatu == '编辑') {
				let { id } = this.activeTrigger;
				(requestApi = api.taskflow.updateAutoTrigger + id), (type = 'Patch');
			}

			simpleFormPageCreate(
				{
					api: requestApi,
					type: type,
					data: this.autotriggerGroups,
				},
				res => {
					let obj = Object.assign({}, res);
					obj.taskRuleId = this.taskDetailObj.id;
					return obj;
				}
			)
				.submit()
				.then(async () => {
					this.click({ id: this.activeTaskFlowId });
					this.autoDialogVisible = false;
					if (this.submitStatu == '编辑') {
						this.$message.success('编辑成功');
					} else {
						this.$message.success('新增成功');
					}
				})
				.catch(err => {
					console.log(err);
				});
			callback();
		},
	},
};
</script>

<style lang="scss" scoped>
.el-tag + .el-tag {
  margin-left: 10px;
}

.button-new-tag {
  margin: 5px;
  height: 32px;
  line-height: 30px;
  padding-top: 0;
  padding-bottom: 0;
}

.input-new-tag {
  width: 90px;
  margin-left: 10px;
  vertical-align: bottom;
}

.taskflowConf {
  .custom-tree-node {
    display: flex;
    width: 100%;
    align-items: center;
    justify-content: space-between;

    .group-item {
      font-size: 12px;
      color: #777;
      margin-left: 7px;
    }
  }
}

.task-groups {
  .el-tag {
    margin: 5px;
  }

  .el-icon-edit {
    border-radius: 50%;
    text-align: center;
    position: relative;
    cursor: pointer;
    font-size: 12px;
    height: 16px;
    width: 16px;
    line-height: 16px;
    top: -1px;
    right: -5px;
    color: #409eff;
  }
}

// 自动触发列表
.auto-trigger {
  padding-left: 68px;
  margin-bottom: 20px;

  .trigger-title {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 15px;
  }
}
</style>
